<template>
  <div class="product-versions-info">
    <!-- modal header -->
    <div class="modal__header">
      <h4>
        <span v-if="versionName">{{ versionName }}:</span>
        {{ headerTitle }}
      </h4>

      <!-- the close button -->
      <!-- can't use partial, bc it has functionality. -->
      <!-- @todo add close functionality by hand -->
      <!-- not a fan of this approach, can i clean it up? -->
      <!-- i need to active version, this is what bothers me -->
      <button
        class="modal__close modal__close--product-versions"
        :title="t.closeModal">
        <i class="fa-solid fa-sharp fa-xmark" aria-hidden="true"></i>
        <span class="visually-hidden">{{ t.closeModal }}</span>
      </button>
    </div>

    <!-- modal content -->
    <div class="modal__content">
      <div class="modal__content-top">
        <div class="product-versions__select-label">
          {{ t.switchVariationLabel }}
        </div>
        <div class="product-versions__select">
          <custom-select
            :options="versions"
            v-model="localActiveId"
            type="product-versions" />
        </div>
      </div>

      <div v-if="!objectEmpty(activeVersion)" class="modal__content-bottom">
        <div class="product-versions__tech-infos">
          <div class="product-versions__tech-grid">
            <template v-if="!objectEmpty(activeVersion.tech_items)">
              <div
                v-for="(info, idx) in activeVersion.tech_items"
                :key="idx"
                class="product-versions__tech-grid-item">
                <div class="product-versions__info-type">
                  {{ info.type }}
                </div>
                <div class="product-versions__info-value">
                  {{ info.value }}
                </div>
              </div>
            </template>
            <div v-else class="product-versions__no-results">
              <p>{{ t.noTechInfo }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components.
import CustomSelect from './CustomSelect';
// Utils.
import translationStrings from '../utils/translation-strings';

export default {
  name: 'product-versions-info',
  components: {
    CustomSelect,
  },
  props: {
    headerTitle: {
      type: String,
      required: true,
    },
    versions: {
      type: Array,
      required: true,
    },
    activeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeVersion: {},
      localActiveId: 0,
      t: translationStrings.productVersions,
      versionName: '',
    };
  },
  watch: {
    activeId(newId) {
      this.localActiveId = newId;
    },
    localActiveId(newId) {
      if (newId) {
        this.getActiveVersion(newId);
        this.versionName = this.activeVersion.label;
      }
    },
  },
  mounted() {
    this.localActiveId = this.activeId;
    this.getActiveVersion(this.localActiveId);

    if (!this.objectEmpty(this.activeVersion)) {
      this.versionName = this.activeVersion.label;
    }
  },
  methods: {
    getActiveVersion(id) {
      this.activeVersion = this.versions.find((v) => v.id === id) || {};
    },
    objectEmpty(obj) {
      // @todo make this reusable already
      return obj !== null && Object.keys(obj).length === 0;
    },
  },
};
</script>
